import { useEffect, useState } from 'react';
import Footer from '../../../components/common/nextAndPrev';
import NodeCard from './nodeCard';
import { getUserDetails } from '../../../services/apisService';
import { makeid } from '../../../utils/common';
import { NodeDataZoneTypes, DefaultObjectType } from '../declaration';

interface Props {
  first: boolean;
  prev: () => void;
  nextPage: () => void;
  countNode: number;
  setCountNode: (n: number) => void;
  nodeDataZone: NodeDataZoneTypes[];
  setNodeDataZone: (obj: any) => void;
  last: boolean;
  submit: () => void;
  defaultObject: DefaultObjectType;
}

const AddNodes = ({
  first,
  prev,
  nextPage,
  countNode,
  setCountNode,
  nodeDataZone,
  setNodeDataZone,
  last,
  submit,
  defaultObject,
}: Props) => {
  const [nodeFlag, setNodeFlag] = useState<boolean>(false);
  const [userName, setUserName] = useState<string>('');

  const getUsername = async () => {
    let name = `a${makeid(4)}`;
    const response: any = await getUserDetails();
    if (response && response.success) {
      name = response.data.first_name;
      setUserName(name);
    }
  };

  useEffect(() => {
    getUsername();
    AddNode();
  }, []);

  const getNewObject = () => {
    const nodeObj: NodeDataZoneTypes = {
      email: '',
      userName: '',
      password: '',
      nodeName: '',
      instanceName: '',
      rpcAccessPoint: { https: false, wss: false },
      rpcApi: defaultObject.rpcApi,
    };
    return nodeObj;
  };

  // Adding node
  const AddNode = () => {
    const nodeObj = JSON.parse(JSON.stringify(getNewObject()));
    setCountNode(countNode + 1);
    if (countNode === 0) {
      setNodeDataZone([nodeObj]);
    }
    setCountNode(1);
  };
  const Node = () => {
    const cards = [];
    for (let i = 0; i < countNode; i += 1) {
      cards.push(
        <NodeCard
          key={`node${i}`}
          cardnumber={i}
          nodeDataZone={nodeDataZone}
          setNodeFlag={setNodeFlag}
          setNodeDataZone={setNodeDataZone}
          setNodeCount={setCountNode}
          nodeCount={countNode}
        />,
      );
    }
    return cards;
  };

  const solve = () => {
    if (countNode === 0) {
      return true;
    }
    if (nodeFlag) {
      return false;
    }
    return true;
  };
  return (
    <>
      <div className="col-11 mx-auto">
        <div className="mx-auto">
          <div className="row">
            <h6 className="col-xl-8 col-lg-8 col-sm-12 col-md-12">
              Node Configurations
            </h6>
          </div>
          {Node()}
        </div>
      </div>

      <Footer
        last={last}
        showNext={solve()}
        submit={submit}
        first={first}
        nextPage={nextPage}
        prev={prev}
      />
    </>
  );
};
export default AddNodes;
